import * as React from 'react';
import { View, FlatList, Text, TouchableOpacity, StyleSheet, Platform } from "react-native";

import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors';
import ModelBackgroundImage from '../common/ModelBackgroundImage';


interface IProps {
    index: number,
    model: any,
    action?: Function,
    rounded?: boolean
}

const GridView: React.FC<IProps> = function ({ index, model, action, rounded }) {

    return (
        <>
            <TouchableOpacity
                style={[
                    styles.container,
                    index % 3 < 2 ? styles.containerWithBorder : null,
                ]}
                onPress={(e) => action && typeof action == 'function' ? action() : null}
            >
                <View style={styles.imageContainer}>
                    <View style={styles.ghostHeight}></View>
                    {
                        model?.upload?.path
                            ? <ModelBackgroundImage
                                model={model}
                                style={[
                                    styles.imageBg,
                                    rounded && styles.imageBgRounded,
                                ]}
                                resizeMode="contain"
                            />
                            : <View style={styles.dummyImage}></View>
                    }
                </View>

                <View style={styles.infoContainer}>
                    {
                        model?.name
                            ? <Text
                                style={styles.modelName}
                                numberOfLines={2}
                            >{model?.name}</Text>
                            : <>
                                <View style={styles.dummyText}></View>
                                <View style={[styles.dummyText, { width: '40%', marginTop: 4 }]}></View>
                            </>
                    }

                    {/* <Text
                        style={styles.modelDescription}
                    >{model?.description} some description text we don't need for now</Text> */}
                </View>

            </TouchableOpacity>

        </>
    )
}

export default GridView

const styles = StyleSheet.create({
    container: {
        width: 100 / 3 + '%',
        borderStyle: 'solid',
        borderColor: Colors.whiteColor,
        borderBottomWidth: 1,
        backgroundColor: Colors.whiteColor,
    },
    containerWithBorder: {
        borderRightWidth: 1,
    },
    imageContainer: {
        flexDirection: 'row',
        width: '80%',
        alignSelf: 'center',
        alignItems: 'flex-end',
        justifyContent: 'center',
    },
    ghostHeight: {
        paddingTop: '100%',
        width: 0,
        flexShrink: 1
    },
    imageBg: {
        // width: '80%',
        // height: '80%',
        width: 80,
        height: 80,

    },
    imageBgRounded: {
        borderRadius: 1000,
        overflow: 'hidden',
    },
    dummyImage: {
        width: '80%',
        height: '80%',
        borderRadius: 1000,
        alignSelf: 'flex-end',
        backgroundColor: Colors.borderColor
    },
    dummyText: {
        width: '65%',
        height: 10,
        borderRadius: 20,
        alignSelf: 'center',
        backgroundColor: Colors.borderColor
    },
    infoContainer: {
        padding: 10,
    },
    modelName: {
        ...FontStyles.size14,
        ...FontStyles.lh18,
        ...FontStyles.normal,
        ...FontStyles.dark,
        textAlign: 'center',
    },
    modelDescription: {
        ...FontStyles.size12,
        ...FontStyles.lh14,
        ...FontStyles.normal,
        ...FontStyles.gray,
        marginTop: 2,
        textAlign: 'center',
    },
})